export const SPENDSLIST = "SPENDSLIST"
export const SPENDSLIST_SUCCESS = "SPENDSLIST_SUCCESS"
export const SPENDSLIST_FAILED = "SPENDSLIST_FAILED"
export const SPEND = "SPEND"
export const SPEND_SUCCESS = "SPEND_SUCCESS"
export const SPEND_FAILED = "SPEND_FAILED"
export const SPENDTRANSACTIONLIST = "SPENDTRANSACTIONLIST"
export const SPENDTRANSACTIONLIST_SUCCESS = "SPENDTRANSACTIONLIST_SUCCESS"
export const SPENDTRANSACTIONLIST_FAILED = "SPENDTRANSACTIONLIST_FAILED"
export const ADDSPEND = "ADDSPEND"
export const ADDSPEND_SUCCESS = "ADDSPEND_SUCCESS"
export const ADDSPEND_FAILED = "ADDSPEND_FAILED"
export const UPDATESPEND = "UPDATESPEND"
export const UPDATESPEND_SUCCESS = "UPDATESPEND_SUCCESS"
export const UPDATESPEND_FAILED = "UPDATESPEND_FAILED"
export const DELETESPEND = "DELETESPEND"
export const DELETESPEND_SUCCESS = "DELETESPEND_SUCCESS"
export const DELETESPEND_FAILED = "DELETESPEND_FAILED"